import ListItem from '@mui/material/ListItem';
import clsx from 'clsx';
import {useSidebarContext} from 'main/utility/AppContextProvider/SidebarContextProvider';
import PropsTypes from 'prop-types';
import {Fonts, MenuStyle} from 'shared/constants/AppEnums';

const VerticalNavItem = ({children, level, ...rest}) => {
  const {
    sidebarTextColor,
    sidebarMenuSelectedBgColor,
    sidebarMenuSelectedTextColor,
    sidebarMenuSelectedBarColor,
    sidebarMenuHoverBgColor,
    sidebarMenuHoverTextColor,
    menuStyle,
  } = useSidebarContext();

  return (
    <ListItem
      className={clsx('menu-vertical-item', {
        'rounded-menu': menuStyle === MenuStyle.ROUNDED,
        'rounded-menu-reverse': menuStyle === MenuStyle.ROUNDED_REVERSE,
        'standard-menu': menuStyle === MenuStyle.STANDARD,
        'curved-menu': menuStyle === MenuStyle.CURVED_MENU,
      })}
      sx={{
        height: 40,
        my: 0.25,
        cursor: 'pointer',
        textDecoration: 'none !important',
        mx: 2,
        width: 'calc(100% - 16px)',
        pl: 22 + 12 * level + 'px',
        pr: 3,
        borderRadius: 1,
        position: 'relative',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        whiteSpace: 'nowrap',
        letterSpacing: '0.5px',
        '& .nav-item-icon': {
          color: sidebarTextColor,
          fontSize: 20,
          display: 'block',
        },
        '& .nav-item-text': {
          color: sidebarTextColor,
          fontWeight: Fonts.MEDIUM,
          fontSize: 14,
        },

        '& .MuiTouchRipple-root': {
          zIndex: 1,
        },
        '&.nav-item-header': {
          textTransform: 'uppercase',
        },
        '&:hover, &:focus': {
          '& .nav-item-text, & .nav-item-icon, & .nav-item-icon-arrow': {
            color: sidebarMenuHoverTextColor,
          },
        },
        '&.active': {
          backgroundColor: sidebarMenuSelectedBgColor,
          pointerEvents: 'none',
          '& .nav-item-text': {
            color: sidebarMenuSelectedTextColor + '!important',
            fontWeight: Fonts.MEDIUM,
          },
          '& .nav-item-icon': {
            color: sidebarMenuSelectedTextColor + '!important',
          },
        },
        '&.rounded-menu': {
          mr: 4,
          ml: 0,
          width: 'calc(100% - 16px)',
          pl: 30 + 12 * level + 'px',
          pr: 3,
          borderRadius: '0 30px 30px 0',
        },
        '&.rounded-menu-reverse': {
          ml: 4,
          mr: 0,
          width: 'calc(100% - 16px)',
          pl: 14 + 12 * level + 'px',
          pr: 3,
          borderRadius: '30px 0 0 30px',
        },
        '&.standard-menu': {
          mx: 0,
          width: '100%',
          pl: 30 + 12 * level + 'px',
          pr: 3,
          borderRadius: 0,
          borderLeft: '4px solid transparent',
          position: 'relative',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

          '&:hover': {
            backgroundColor: sidebarMenuHoverBgColor,
            '& .nav-item-text, & .nav-item-icon': {
              color: sidebarMenuHoverTextColor, // Keep text white on hover
            },
          },

          '&.active': {
            backgroundColor: sidebarMenuSelectedBgColor, // This is your YAMAN_GOLD
            borderLeft: `4px solid ${sidebarMenuSelectedBarColor}`,
            '& .nav-item-text, & .nav-item-icon': {
              color: sidebarMenuSelectedTextColor, // Switches to Onyx for high-contrast on Gold
              // fontWeight: 700,
            },
          },
        },
        '&.curved-menu': {
          ml: 4,
          mr: 0,
          width: 'calc(100% - 16px)',
          pl: 14 + 12 * level + 'px',
          pr: 3,
          borderRadius: '30px 0 0 30px',
          position: 'relative',
          transition: 'none',
          '&:before, &:after': {
            content: '""',
            position: 'absolute',
            right: 0,
            zIndex: 1,
            height: 40,
            width: 40,
            backgroundColor: 'transparent',
            borderRadius: '50%',
            opacity: 0,
          },
          '&:before': {
            top: -40,
            boxShadow: `30px 30px 0 10px transparent`,
          },
          '&:after': {
            bottom: -40,
            boxShadow: `30px -30px 0 10px transparent`,
          },
          '&:hover, &.active': {
            backgroundColor: sidebarMenuSelectedBgColor,
            '& .nav-item-text, & .nav-item-icon': {
              color: sidebarMenuSelectedTextColor + '!important',
            },
            '&:before': {
              boxShadow: `30px 30px 0 10px ${sidebarMenuSelectedBgColor}`,
              opacity: 1,
            },
            '&:after': {
              boxShadow: `30px -30px 0 10px ${sidebarMenuSelectedBgColor}`,
              opacity: 1,
            },
          },
          '& .MuiTouchRipple-root': {
            display: 'none',
          },
        },
      }}
      {...rest}
    >
      {children}
    </ListItem>
  );
};

export default VerticalNavItem;

VerticalNavItem.propTypes = {
  children: PropsTypes.node,
  level: PropsTypes.number,
};
